/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NamedStringResource
 */
export interface NamedStringResource {
    /**
     * 
     * @type {string}
     * @memberof NamedStringResource
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof NamedStringResource
     */
    value?: string;
}

/**
 * Check if a given object implements the NamedStringResource interface.
 */
export function instanceOfNamedStringResource(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NamedStringResourceFromJSON(json: any): NamedStringResource {
    return NamedStringResourceFromJSONTyped(json, false);
}

export function NamedStringResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): NamedStringResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function NamedStringResourceToJSON(value?: NamedStringResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

